import { render, staticRenderFns } from "./BtnAtualizarEvento.vue?vue&type=template&id=f87e6770"
import script from "./BtnAtualizarEvento.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports